module.exports = __webpack_public_path__ + "static/img/cry.f707265.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cry.gif
// module id = Rf6T
// module chunks = 81